module.exports = __webpack_public_path__ + "static/media/bathTempSmall.47557980.svg";